import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_JANUS_API_URL;
const janusAPI = axios.create({
  baseURL: API_URL,
  responseType: "json",
});

janusAPI.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default janusAPI;
